import React from 'react';
import { NavbarElementProps } from 'react-day-picker/types/Props';
import { Box, Icon } from '@chakra-ui/react';
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/all';

export const DayPickerNavBar = (
  props: NavbarElementProps & { header?: JSX.Element },
): JSX.Element => {
  const { onPreviousClick, onNextClick, className, header } = props;
  return (
    <Box className={className} mb={4}>
      <Icon
        onClick={() => onPreviousClick()}
        as={MdNavigateBefore}
        color={'blue.500'}
        fontSize={'4xl'}
        _hover={{
          cursor: 'pointer',
          backgroundColor: 'blue.100',
          borderRadius: 24,
        }}
      />
      {header}
      <Icon
        onClick={() => onNextClick()}
        as={MdNavigateNext}
        color={'blue.500'}
        fontSize={'4xl'}
        _hover={{
          cursor: 'pointer',
          backgroundColor: 'blue.100',
          borderRadius: 24,
        }}
      />
    </Box>
  );
};
